function pause_videos() {
	var videos = document.getElementsByTagName('video')
  for(var i = 0; i < videos.length; i++){
	videos[i].pause();
  }
}


	//--------------------- Carousel Videos
	function check_for_video(cid){
		var player  = false;
		var playing = false;
		var video = $(cid+' .owl-item.active video')
		var item = $(cid+' .owl-item.active .item');
		var is_video = item.hasClass('is-video');
		if( is_video ){
			player = $(cid+' .owl-item.active video')[0];
		}
		// is the item a video slider

		// check for the previous video to have already been playing
		if(player && playing ){
			item.removeClass('playing').addClass('paused');
			player.pause();
			playing = false;
		}


		// this new slide is a video
		// play it
		if( is_video  && player ){
			//------------------ If its not mobile
			if(!playing){
				item.removeClass('paused').addClass('playing');
				player.play();
				playing = true;
			}
		}
		//end if it's a video
	}




jQuery(document).ready(function($) {

  //  	//remove the default search word from search
  //  	  $('#tribe-bar-form').on("submit", function(){
  //       if($("#tribe-bar-search").val() == 'Search')
  //           $("#tribe-bar-search").val(''); // clear the value
  //       if($("#tribe-bar-date").val() == 'Date')
  //           $("#tribe-bar-date").val(''); // clear the value
  //       return true; // submit the form
	// });
	// $('.tribe-bar-views-option a').on('click touch', function(){
	// 	if($("#tribe-bar-search").val() == 'Search')
  //           $("#tribe-bar-search").val(''); // clear the value
  //       if($("#tribe-bar-date").val() == 'Date')
  //           $("#tribe-bar-date").val(''); // clear the value
	// });
	//  $('#tribe-bar-form').on('change', function(){
	//  	if($("#tribe-bar-search").val() == 'Search')
  //           $("#tribe-bar-search").val(''); // clear the value
	// 	if($("#tribe-bar-date").val() == 'Date')
  //           $("#tribe-bar-date").val(''); // clear the value
	//  });



	$('.main-header').on('touchstart click', function(){
	    var url  = document.location.origin;
	    $(".navbar-brand").attr("href", url);
	});
    $('.overlay').on('touchstart click', function(){
	    $(".navbar-brand").attr("href", "#");
    });
/*
		Trial(".main-header")
		.within(
		    {distance: 500, cord: 'center'},
		    function(distance, ele, event){
			    $(' .main-header , .main-header .main-nav').css('width' , 70 + distance / 100 + 'px');
		    }
		);
*/
    // SMOOTH SCROLL

    $('.scroller a').click(function() {
	    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
	      var target = $(this.hash);
	      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
	      if (target.length) {
	        $('html,body').animate({
	          scrollTop: target.offset().top
	        }, 1000);
	        return false;
	      }
	    }
	  });

	// SCROLL TO ANCHOR LINK ON ANOTHER PAGE

    // if (window.location.hash) {
	//     if( $(window.location.hash).length > 0) {
    //     setTimeout(function() {
    //         $('html, body').scrollTop(0).show();
    //         $('html, body').animate({
    //             scrollTop: $(window.location.hash).offset().top
    //             }, 1000)
    //     }, 0);
    //    }
    // }




    /* !----------------- DESKTOP ONLY ------------------! */
	if( ($('body').hasClass('desktop') == true) ){
		var menu_timeout = false;
		var left_menu = false;
	    $('.main-header').mouseenter(function(){
		    left_menu = false;
		    setTimeout(function(){
			    if(!left_menu){
				    $('.main-header').addClass('open').attr( 'aria-expanded' , 'true' );
				    $('.overlay').fadeIn();
				     var url  = document.location.origin;
					 $(".navbar-brand").attr("href", url);
				    left_menu = false;
				  }
		    },400);
	    });

	    $('.main-header').mouseleave(function(){
		    left_menu = true;
	    });
	    $('.overlay').on('click ', function(){
		    $('.main-header').removeClass('open').attr( 'aria-expanded' , 'false' );
		    $('.sub-menu-list-container').removeClass('showme');
		    $(this).fadeOut();
	    });


		var navCount = $('.dot li').length;
			navCount = 100 / navCount;
			navCount = navCount.toFixed(2);
			//console.log(navCount);
		$('.dot li').css({
			'height': navCount+'%'
		});

		$('.dropdown-toggler').on('click', function(e){
			e.preventDefault();
			var thisID = $(this).attr('attr-target');
			//console.log(thisID);
			//------if the dropdown is showing
			if ($('.main-header').hasClass('drop')){
				// if the same link is clicked
				if ($(thisID).hasClass('shown')){
					$('.main-header').removeClass('drop');
					$(thisID).removeClass('shown');
					$(this).removeClass('active');
				// if a different dropdown is clicked
				} else {
					$('.navbar-dropdown').removeClass('shown');
					$('.dropdown-toggler').removeClass('active');
					$(thisID).addClass('shown');
					$(this).addClass('active');
				}
				//$('.main-header').removeClass('drop');
				//$(thisID).removeClass('shown');
			//------if the dropdown is hidden, open the dropdown
			} else {
				$(this).addClass('active');
				$('.main-header').addClass('drop');
				$(thisID).addClass('shown');
			}

			//------ Sub Sub Menu
			$('.sub-sub-link').on('click', function(e){
				e.preventDefault();
				var linkTarget = $(this).attr('data-target');
				console.log(linkTarget);
				$('.'+linkTarget+'').addClass('showme');
			});
			$('.sub-menu-list-container .btn-back').on('click', function(){
				$('.sub-menu-list-container').removeClass('showme');
			});
			$('.drop-back').on('click', function(e){
				e.preventDefault();
				$('.main-header').removeClass('drop');
				$('.navbar-dropdown').removeClass('shown');
				$('.dropdown-toggler').removeClass('active');
			});


		});


		/*
		 *
		 * ------------------ SCROLL MAGIC STUFF
		 *
		 */
		var controller = new ScrollMagic.Controller({ globalSceneOptions: { duration: '100%' } });

		// get all slides
		var slides = document.querySelectorAll(".home-sec");

		// create scene for every slide
		for (var i=0; i<slides.length; i++) {
			// current slide
			var slide = slides[i];
			// trigger nav-calss change for each slide
			new ScrollMagic.Scene({	triggerElement: slide })
				.setClassToggle('.sec-'+i, 'active' )
				//.setPin(slide)
				//.addIndicators() // add indicators (requires plugin)
				.addTo(controller);
		}

	/* !----------------- Tablet & Phone ------------------! */
    } else {

	    $('.main-header').on('touchstart click', function(e){
			if( !$('.main-header').hasClass('open')){
				e.preventDefault();
				$(this).addClass('open').attr( 'aria-expanded' , 'true' );
				$('.overlay').fadeIn();
			}
	    });
	    $('.overlay').on('touchstart click', function(){
		    $('.main-header').removeClass('open').attr( 'aria-expanded', 'false');
		    $(this).fadeOut();
	    });
    }


	$('.navbar-closer').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();
		$('.main-header').removeClass('open drop').attr( 'aria-expanded' , 'false' );
		$('.sub-menu-list-container').removeClass('showme');
		$('.overlay').fadeOut();
	});



			/* != Home Carousel
			-------------------------------------------------------------- */
			$('.mx-intro-slider').owlCarousel({
			    loop:false,
			    margin:0,
				items:1,
				nav: false,
				dots: true,
				onInitialized: function(){
					check_for_video('.mx-intro-slider');
				},
				onTranslated: function() {
					pause_videos();
					check_for_video('.mx-intro-slider');
				}
			});

			$.each($('.mx-intro-slider .owl-dot'),function(i, v){
				var homedataText = $('.mx-intro-slider [data-dott="'+i+'"]').attr('data-text');
				if( typeof( homedataText ) !== 'undefined' )
					$(this).html('<span>'+homedataText+'</span>');
			});



		$('.mx-row-callout .owl-carousel, .pub-carousel.owl-carousel').owlCarousel({
				loop:true,
				margin:0,
				items:1,
				nav: false,
				dots: true
		});
		$('.brew-notes .owl-carousel').owlCarousel({
				loop:true,
				margin:0,
				items:1,
				nav: true,
				dots: true
		});


		var pubCarousel = function(){
			/* != Pubs Carousel
			-------------------------------------------------------------- */
			$('.pub-carousel').owlCarousel({
				loop:false,
				margin:0,
				nav:true,
				navText:['<span></span>','<span></span>'],
				items:1,
				dots: true,
				onInitialized: function(){
					check_for_video('#pubsCarousel');
				},
				onTranslated: function() {
					pause_videos();
					check_for_video('#pubsCarousel');
				}
			});
			$.each($('.pub-carousel .owl-dot'),function(i, v){
				var pubsdataText = $('#pubsCarousel [data-dott="'+i+'"]').attr('data-text');
				var pubsdataIcon = $('#pubsCarousel [data-dott="'+i+'"]').attr('data-icon');
				$(this).html('<i class="icon-'+pubsdataIcon+'"></i><span>'+pubsdataText+'</span>');
			});
		}
		/* != Pubs Carousel
		-------------------------------------------------------------- */
		$('.pubs-carousel').owlCarousel({
			loop:false,
			margin:0,
			nav:true,
			navText:['<span></span>','<span></span>'],
			items:1,
			dots: true,
			onInitialized: function(){
				check_for_video('#pubsCarousel');
			},
			onTranslated: function() {
				pause_videos();
				check_for_video('#pubsCarousel');
			}
		});
		$.each($('.pubs-carousel .owl-dot'),function(i, v){
			var pubsdataText = $('.pubs-carousel [data-dott="'+i+'"]').attr('data-text');
			var pubsdataIcon = $('.pubs-carousel [data-dott="'+i+'"]').attr('data-icon');
			$(this).html('<i class="icon-'+pubsdataIcon+'"></i><span>'+pubsdataText+'</span>');
		});


/*

	window.setTimeout(function(){
		if($('[name="tribe-bar-date"]').val() == 'Date') $('[name="tribe-bar-date"]').val('');
		if($('[name="tribe-bar-search"]').val() == 'Search') $('[name="tribe-bar-search"]').val('');
		if($('[name="tribe-bar-search"]').val() == 'Keyword') $('[name="tribe-bar-search"]').val('');
	}, 100);
*/
$('#tribe-bar-form').off( 'submit' );

$('.tribe-events-nav-previous').off( 'click' );
$('.tribe-events-nav-next').off( 'click' );

$("input[name='submit-bar']").on( 'click', function( $e ){
	$e.preventDefault();
	$e.stopPropagation();
	$($(this).closest( 'form' )).submit();
} );



   //handle tall featured images
	$(window).on( 'load', function(){
	 $(".blog-roll .feat-img, .search-result .feat-img").find('img').each(function(){
	  var imgClass = (this.width/this.height > 1) ? 'wide' : 'tall';
	  $(this).addClass(imgClass);
	 })
	})

	//tooltips on all beers list
	$(function () {
		$('[data-toggle="tooltip"]').tooltip()
	})

});
